export const decodeBase64Image = (imageString: string) => {
    if (!imageString) return ''; // Handle the case where imageString is empty
    const bytes = new Uint8Array(atob(imageString).split('').map(char => char.charCodeAt(0)));
    return URL.createObjectURL(new Blob([bytes], { type: 'image/png' }));
  };
  